export const CART_STORE_ID = 'cart';
